import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "../ApiUtils";


const questionApiUrl = `${baseApiUrl}/api/Question`;

export async function getQuestion() {
    return await httpRequest(fetchQuestion.bind(this));
}

async function fetchQuestion() {
    let config = getHttpHeaders();
    return await axios.get(`${questionApiUrl}`, config);
}

export async function getQuestionById(id) {
    return await httpRequest(fetchQuestionById.bind(this, id));
}

async function fetchQuestionById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${questionApiUrl}/${id}`, config);
}

export async function getQuestionByGroupId(groupId) {
    return await httpRequest(fetchQuestionByGroupId.bind(this, groupId));
}

async function fetchQuestionByGroupId(groupId) {
    let config = getHttpHeaders();
    return await axios.get(`${questionApiUrl}/Group/${groupId}`, config);
}

export async function addQuestion(newQuestion) {
    return await httpRequest(postQuestion.bind(this, newQuestion));
}

async function postQuestion(newQuestion) {
    let config = getHttpHeaders();
    return await axios.post(`${questionApiUrl}`, newQuestion, config);
}

export async function updateQuestion(updatedQuestion) {
    return await httpRequest(putQuestion.bind(this, updatedQuestion));
}

async function putQuestion(updatedQuestion) {
    let config = getHttpHeaders();
    return await axios.put(`${questionApiUrl}`, updatedQuestion, config);
}

export async function deleteQuestion(id) {
    return await httpRequest(fetchDeleteQuestion.bind(this, id));
}

async function fetchDeleteQuestion(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${questionApiUrl}/${id}`, config);
}

export async function updateQuestionOrder(questionOrder) {
    return await httpRequest(putQuestionOrder.bind(this, questionOrder));
}

async function putQuestionOrder(questionOrder) {
    let config = getHttpHeaders();
    return await axios.put(`${questionApiUrl}/Order`, questionOrder, config);
}